import styled from 'styled-components';

export const Wrap = styled.div`
  height: 40px;
  display: flex;
  gap: 8px;
  align-items: center;
  color: white;
`;

export const LoaderWrap = styled(Wrap)`
  justify-content: center;
`;

export const Title = styled.p`
  margin-right: auto;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const Value = styled.p`
  font-size: 32px;
  line-height: 40px;
  font-weight: 800;
`;

export const IconWrap = styled.div`
  flex-shrink: 0;
`;
